export const FIREBASECOLLECTION = {
    USERS: "users",
    POSTS: "posts",
    COMMENTS: "comments",
    LIKES: "likes",
    MESSAGES: "messages",
    ROOMS: "rooms",
  };
  